<template>
  <div class="site-create-card-container">
    <div class="site-create-card-head">
      <div class="hot-area" @click="toogleIsHide">
        <a-icon type="caret-down" class="icon" :class="{ rotate: isHide }" />
      </div>
      <div class="title">{{ title }}</div>
      <slot name="action"></slot>
    </div>
    <div class="content" ref="content" :style="{ height: height }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
   props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isHide: false,
      height: 'unset'
    }
  },
 mounted() {
     if(this.title === '黑白名单配置' || this.title === '高级配置') {
       this.hide()
     }
 },
  methods: {
    toogleIsHide() {
      if (this.isHide) {
        this.show()
      } else {
        this.hide()
      }
    },

    show() {
      this.height = 'unset'
      this.isHide = false
    },

    hide() {
      let content = this.$refs.content
      this.height = '0px'
      this.isHide = true
    }
  }
}
</script>

<style lang="less" scoped>
.site-create-card-container {
  width: 100%;
  padding: 10px 30px 0;
  background: white;
  border-radius: 4px;

  .site-create-card-head {
    height: 55px;
    display: flex;
    align-items: center;
    /*border-bottom: 1px solid #ebebeb;*/
    margin-bottom: 10px;

    .hot-area {
      height: 100%;
      width: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      cursor: pointer;

      .icon {
        font-size: 16px;
        transition: all 0.2s;
          color: #4683FF;

        &.rotate {
          transform: rotate(180deg);
        }
      }
    }

    .title {
      color: #333333;
      font-weight: bold;
      font-size: 16px;
      height: 16px;
      line-height: 16px;
    }
  }

  .content {
    transition: all 0.2s;
    overflow: hidden;
  }
}
</style>
